// extracted by mini-css-extract-plugin
export default {"ChoiceOption":"📚19-10-2JrUHk","selected":"📚19-10-2MLoDE"};